import { AccountMenu, HeaderContainer } from '@/scopes/common/components/Header'
import styles from './Header.module.css'

export function Header() {
  return (
    <HeaderContainer backgroundColor="transparent">
      <div className={styles.content}>
        <AccountMenu />
      </div>
    </HeaderContainer>
  )
}
